import axios from "axios";
import {
  BASE_API_URL,
  unsubLinks,
  unsubscribeText,
} from "../constants/constants";
import { messages } from "../constants/messages";
import { config } from "../constants/domainConfig";
import { sendData } from "../analytics/sendData";
import { isMundo360 } from "../constants/multiDomains";

export const onUnsubClick = (e, showMessage) => {
  const domain = "mx.mundo-360.com";
  if (e) e.preventDefault();
  const uid = JSON.parse(sessionStorage.getItem("authorized"))
    ? JSON.parse(sessionStorage.getItem("authorized")).uid
    : "";
  sendData("", "", "video", "unsubscribe clicked");
  const staging =
    sessionStorage.getItem("staging") === "true" ||
    sessionStorage.getItem("staging") === "1";
  if (staging) {
    if (config.domain === "za") {
      window.open(
        `http://ads-za-yola.sam-media.com/unsubscribe/za1?country=eg&lang=eg&token=${uid}`,
      );
    } else if (config.domain === "be") {
      window.open(
        `http://staging-prox.vidzmapping.be/unsubscribe/be/?country=be&domain=be.mobio360.com&token=${uid}`,
      );
    }
  }
  if (config.domain === "mx" && isMundo360()) {
    axios
      .get(`${BASE_API_URL}/unsubscribe`, {
        params: {
          domain: domain,
          country: config.country,
          token: uid,
        },
      })
      .then((resp) => {
        const t = messages[config.lang];
        const msg =
          resp.status === 200 && resp.data.data.success
            ? t.unsubscribeSuccess
            : resp.data.data.reason === "SUB_NOT_FOUND"
              ? t.unsubscribeNotFound
              : t.unsubscribeFailed;
        showMessage &&
          showMessage({
            message: msg,
            type: resp.status === 200 && resp.data.data.success,
          });
      })
      .catch((err) => {
        const t = messages[config.lang];
        showMessage &&
          showMessage({ message: t.unsubscribeFailed, type: false });
      });
    return;
  }
  if (unsubLinks[config.domain]) {
    const unsubUrl = new URL(unsubLinks[config.domain]);

    if (config.lang === "be") unsubUrl.searchParams.append("lang", "nl");
    else if (config.domain === "sa") unsubUrl.searchParams.append("lang", "en");
    else unsubUrl.searchParams.append("lang", config.lang);

    unsubUrl.searchParams.append("token", uid);
    window.open(unsubUrl.href);
  }
};

export const unsubscribeTextFun = () => {
  if (unsubscribeText[config.domain]) {
    const unsubText = unsubscribeText[config.domain];
    return unsubText;
  }
};



// WEBPACK FOOTER //
// ./src/utils/unsubHelper.js